const Footer = () => (
    <footer className="bg-gray-800 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-400 text-sm">
            <p>&copy; {new Date().getFullYear()} Olakh. All rights reserved.</p>
            <p className="mt-2"> <a href='/privacypolicy'>Privacy Policy</a></p>
            {/* <p className="mt-2"> <a href='/privacypolicy'>Privacy Policy</a> | Terms of Service</p> */}
        </div>
    </footer>
);

export default Footer;